/**
 * Check if wishlist functionality is enabled based on environment variables
 * This is a client-side check that assumes wishlist is enabled if the API endpoints exist
 */
export function isWishlistEnabled(): boolean {
  // On client-side, we assume wishlist is enabled and let the API handle the actual token validation
  // This prevents issues with server-only environment variables in client components
  return true;
}
